const LEVELS = ['Mínima', 'Baixa', 'Média', 'Alta', 'Máxima']

type RelevanceSliderProps = {
  value: number // 1–5
  onChange: (value: number) => void
  label?: string
  disabled?: boolean
  onEnable?: () => void
}

export function RelevanceSlider({
  value,
  onChange,
  label = 'Relevância',
  disabled = false,
  onEnable,
}: RelevanceSliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      onEnable?.()
      // Aguardar um tick para a disciplina ser selecionada antes de processar
      setTimeout(() => {
        const val = Number(e.target.value)
        onChange?.(val)
      }, 0)
    } else {
      const val = Number(e.target.value)
      onChange?.(val)
    }
  }

  const handleMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
    if (disabled) {
      onEnable?.()
    }
  }

  return (
    <div className="knowledge-slider">
      <div className="slider-header">
        <span>{label}</span>
        <span className="slider-value">{value}</span>
      </div>

      <input
        type="range"
        min={1}
        max={LEVELS.length}
        step={1}
        value={value || 1}
        onChange={handleChange}
        onMouseDown={handleMouseDown}
        className={`slider ${disabled ? 'disabled' : ''}`}
        style={{ color: '#3b82f6' }}
        aria-label="Nível de relevância"
      />
    </div>
  )
}
